import { useState, useEffect } from "react";
import { useLocalStorage } from "./useLocalStorage";
import { Household } from "@/types/types";

const useSelectedClient = (household: Partial<Household> | undefined, lsKey: string) => {
  const { readData, saveData } = useLocalStorage();
  const [selectedClient, setSelectedClient] = useState<string | null | undefined>(
    household?.primaryContact?.externalCode
  );

  useEffect(() => {
    const clientFromLocalStorage = readData(
      `${lsKey}-client-${household?.externalCode}-${household?.clientCode}`
    );

    if (clientFromLocalStorage && clientFromLocalStorage !== "undefined") {
      setSelectedClient(clientFromLocalStorage);
    } else {
      setSelectedClient(household?.primaryContact?.externalCode);
    }
  }, [household?.externalCode]);

  useEffect(() => {
    if (selectedClient) {
      saveData(
        `${lsKey}-client-${household?.externalCode}-${household?.clientCode}`,
        selectedClient
      );
    }
  }, [selectedClient]);

  return { selectedClient, setSelectedClient };
};

export default useSelectedClient;
